<template lang="pug">
  main#main.manager-organizations
    b-container(fluid)
      wc-breadcrumb(icon='fal fa-building')
      section.l-section
        .l-section-h
          router-view
</template>

<script>
import WcBreadcrumb from '@components/shared/WcBreadcrumb'

export default {
  name: 'manager-organizations',
  components: {
    WcBreadcrumb,
  },
}
</script>
